<template>
  <div class="has-text-centered">
    <h1>Resource Activities</h1>
    <!-- <span>This is a summary of resources pushed and opened, both for *learning paths* or simply pushed into a book, as well as personal resources. Use the tabs to switch between the two kinds. In the learning paths tab, click on the summaries to see more detailed breakdowns of those sections.</span> -->
    <div class="tabs has-text-centered is-boxed is-centered">
        <ul>
            <li :class="{'is-active': activeTab === 1}" style="margin-top: 4px;">
                <a class="has-text-weight-bold" @click="activeTab = 1">Learning Path Resources</a>
            </li>
            <li :class="{'is-active': activeTab === 2}">
                <a class="has-text-weight-bold" @click="activeTab = 2">Book Resources</a>
            </li>
            <li :class="{'is-active': activeTab === 3}">
                <a class="has-text-weight-bold" @click="activeTab = 3">Personal Resources</a>
            </li>
            <li :class="{'is-active': activeTab === 4}">
                <a class="has-text-weight-bold" @click="activeTab = 4">Assessments</a>
            </li>
        </ul>
    </div>
    <div class="horiz-scroll" v-if="resources && activeTab === 1">
        <table class="table is-fullwidth">
            <thead class="thead-default">
                <tr>
                    <th class="has-text-centered">
                        Learning Path Title
                    </th>
                    <th class="has-text-centered" colspan="4">
                        Additional Resources
                    </th>
                    <th class="has-text-centered" colspan="4">
                        Tasks
                    </th>
                </tr>
                <tr>
                    <th></th>
                    <th class="border-left has-text-centered">
                        Available
                    </th>
                    <th class="has-text-centered">
                        Locked
                    </th>
                    <th class="has-text-centered">
                        Opened
                    </th>
                    <th class="has-text-centered">
                        %
                    </th>
                    <th class="border-left has-text-centered">
                        Available
                    </th>
                    <th class="has-text-centered">
                        Locked
                    </th>
                    <th class="has-text-centered">
                        Opened
                    </th>
                    <th class="has-text-centered">
                        %
                    </th>
                </tr>
            </thead>
            <tbody>
                <template v-for="(lp, i) in resources">
                    <tr v-bind:key="'resource' + i" class="resource-hover">
                        <td>{{ lp.name }}</td>
                        <td class="border-left has-text-centered has-cursor-hand" :class="{ 'has-background-light-blue has-text-weight-semibold ': lp.id === expandedLP && additional }"
                            @click="expandLP(lp.id, true)">
                            {{ lp.availableAdditional }}
                        </td>
                        <td class="has-text-centered has-cursor-hand" :class="{ 'has-background-light-blue has-text-weight-semibold ': lp.id === expandedLP && additional }"
                            @click="expandLP(lp.id, true)">
                            {{ lp.lockedAdditional }}
                        </td>
                        <td class="has-text-centered has-cursor-hand" :class="{ 'has-background-light-blue has-text-weight-semibold ': lp.id === expandedLP && additional }"
                            @click="expandLP(lp.id, true)">
                            {{ lp.openAdditional }}
                        </td>
                        <td class="has-text-centered has-cursor-hand" :class="{ 'has-background-light-blue has-text-weight-semibold ': lp.id === expandedLP && additional }"
                            @click="expandLP(lp.id, true)">
                            {{ lp.openAdditional / lp.availableAdditional || 0 | percent }}
                        </td>
                        <td class="border-left has-text-centered has-cursor-hand" :class="{ 'has-background-light-blue has-text-weight-semibold ': lp.id === expandedLP && !additional }"
                            @click="expandLP(lp.id, false)">
                            {{ lp.availableTasks }}
                        </td>
                        <td class="has-text-centered has-cursor-hand" :class="{ 'has-background-light-blue has-text-weight-semibold ': lp.id === expandedLP && !additional }"
                            @click="expandLP(lp.id, false)">
                            {{ lp.lockedTasks }}
                        </td>
                        <td class="has-text-centered has-cursor-hand" :class="{ 'has-background-light-blue has-text-weight-semibold ': lp.id === expandedLP && !additional }"
                            @click="expandLP(lp.id, false)">
                            {{ lp.openTasks }}
                        </td>
                        <td class="has-text-centered has-cursor-hand" :class="{ 'has-background-light-blue has-text-weight-semibold ': lp.id === expandedLP && !additional }"
                            @click="expandLP(lp.id, false)">
                            {{ lp.openTasks / lp.availableTasks || 0 | percent }}
                        </td>
                    </tr>
                    <tr v-if="lp.id === expandedLP" v-bind:key="lp.id" class="has-background-grey-light">
                        <td colspan="9">
                            <div>
                                <table v-if="expandedLPTopics && expandedLPTopics.length > 0" class="table is-full-width has-background-light">
                                    <thead>
                                        <tr>
                                            <th>Topic</th>
                                            <th>Resource Title</th>
                                            <th>Resource Type</th>
                                            <th class="has-text-centered">Opened</th>
                                            <th class="has-text-centered">Locked</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(topic, j) in expandedLPTopics">
                                            <tr v-bind:key="'topic' + j">
                                                <td class="grey-border-bottom pl-2">{{ topic.name }}</td>
                                                <td colspan="6" class="grey-border-bottom"></td>
                                            </tr>
                                            <template v-for="(item, k) in topic.items">
                                                <tr :class="{ 'has-text-grey': item.locked}" v-bind:key="'topic' + j + '-item' + k">
                                                    <td class="resource-icon-container"><img :src="utils.resourceTypeImg(item.resourceType)" width="16"></td>
                                                    <td>{{ item.resourceTitle }}</td>
                                                    <td>{{ item.resourceType | resourceCategory }}</td>
                                                    <td class="has-text-centered has-text-black">
                                                        <span v-if="item.opened" class="icon">
                                                            <i class="fas fa-check"></i>
                                                        </span>
                                                    </td>
                                                    <td class="has-text-centered has-text-black">
                                                        <span v-if="item.locked" class="icon">
                                                            <i class="fas fa-lock"></i>
                                                        </span>
                                                    </td>
                                                </tr>
                                            </template>
                                        </template>
                                        <tr>&nbsp;</tr>
                                    </tbody>
                                </table>
                                <div v-if="!expandedLPTopics || expandedLPTopics.length == 0" class="notification has-text-centered">
                                    No resources to show in this section
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-bind:key="'resource-empty' + i"></tr>
                </template>
            </tbody>
            <tfoot>
                <tr>
                    <th>Totals</th>
                    <th class="border-left has-text-centered">{{ totalAdditional | number }}</th>
                    <th class="has-text-centered">{{ totalLockedAdditional | number }}</th>
                    <th class="has-text-centered">{{ totalOpenAdditional | number }}</th>
                    <th class="has-text-centered">{{ totalAdditional === 0 ? 0 : totalOpenAdditional / totalAdditional | percent }}</th>
                    <th class="border-left has-text-centered">{{ totalTasks | number }}</th>
                    <th class="has-text-centered">{{ totalLockedTasks | number }}</th>
                    <th class="has-text-centered">{{ totalOpenTasks | number }}</th>
                    <th class="has-text-centered">{{ totalTasks === 0 ? 0 : totalOpenTasks / totalTasks | percent }}</th>
                </tr>
            </tfoot>
        </table>
    </div>

    <div class="horiz-scroll removed" v-if="activeTab === 2">
        <table class="table is-fullwidth">
            <thead class="thead-default">
                <tr>
                    <th>
                        Title
                    </th>
                    <th class="has-text-centered">
                        Pushed
                    </th>
                    <th class="has-text-centered">
                        Opened
                    </th>
                    <th class="has-text-centered">
                        %
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, l) in sortedBookResources" v-bind:key="'sortedBookResource' + l"> 
                    <td>{{ row.title }}</td>
                    <td class="has-text-centered">{{ row.total }}</td>
                    <td class="has-text-centered">{{ row.seen }}</td>
                    <td class="has-text-centered">{{ row.seen / row.total | percent }}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <th>Totals</th>
                    <th class="has-text-centered">{{ totalPushed | number }}</th>
                    <th class="has-text-centered">{{ totalOpened | number }}</th>
                    <th class="has-text-centered">{{ totalAvg | percent }}</th>
                </tr>
            </tfoot>
        </table>
    </div>

    <div v-if="sortedPrivateResources && activeTab === 3" class="horiz-scroll removed">
        <table v-if="sortedPrivateResources.length > 0" class="table is-fullwidth">
            <thead>
                <tr>
                    <th>Type</th>
                    <th class="has-text-centered">Created</th>
                    <th class="has-text-centered"></th>
                    <th class="has-text-centered">Group Avg</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, m) in sortedPrivateResources" v-bind:key="'sortedPrivateResource' + m">
                    <td>{{ row.category | resourceCategory }}</td>
                    <td class="has-text-centered">{{ row.count }}</td>
                    <td v-if="row.count === row.avg" class="has-text-centered has-text-success">=</td>
                    <td v-if="row.count < row.avg" class="has-text-centered has-text-danger">&lt;</td>
                    <td v-if="row.count > row.avg" class="has-text-centered has-text-success">&gt;</td>
                    <td class="has-text-centered">{{ row.avg | number }}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <th>Totals</th>
                    <th class="has-text-centered">{{ totalPrivateCreated }}</th>
                    <th></th>
                    <th class="has-text-centered">{{ avgPrivateCreated | number}}</th>
                </tr>
            </tfoot>
        </table>
        <div v-if="sortedPrivateResources.length === 0" class="notification is-warning has-text-centered">
            No personal resources have been created
        </div>
    </div>
    <div v-if="assessments && activeTab === 4" class="horiz-scroll removed">
        <table v-if="assessments.length > 0" class="table is-fullwidth">
            <thead>
                <tr>
                    <th>Group Name</th>
                    <th>Assessments Completed</th>
                    <th>Assessments Available</th>
                    <th>% Completed</th>
                </tr>
            </thead>
            <tbody>
                <template v-for="(assessmentGroup) in assessments">
                    <tr 
                        v-bind:key="'assessmentGroup' + assessmentGroup.groupId" 
                        class="has-cursor-hand"
                        @click="expandAssessmentDetails(assessmentGroup.groupId)"
                        :class="{ 'has-background-light-blue has-text-weight-semibold ': assessmentGroup.groupId === expandedAssessmentGroupId }"
                    >
                        <td>{{ assessmentGroup.groupName }}</td>
                        <td>{{ assessmentGroup.completed }}</td>
                        <td>{{ assessmentGroup.available }}</td>
                        <td>{{ assessmentGroup.completed / assessmentGroup.available | percent }}</td>
                    </tr>
                    <tr v-if="expandedAssessmentGroupId === assessmentGroup.groupId" v-bind:key="'assessmentGroup' + assessmentGroup.groupId" >
                        <td colspan="4">
                            <div>
                                <table class="table is-fullwidth is-narrow has-background-light">
                                    <thead>
                                        <tr>
                                            <th>Assessment Name (Instance Name)</th>
                                            <th>Total Attempts</th>
                                            <th>Marks Attained</th>
                                            <th>Marks Available</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(assessment, n) in assessmentsDetailsByGroupId[assessmentGroup.groupId]" v-bind:key="'assessment' + n" >
                                            <td>{{ assessment.assessmentName }} ({{ assessment.instanceName }})</td>
                                            <td>{{ assessment.attempts }}</td>
                                            <td>{{ assessment.mark }}</td>
                                            <td>{{ assessment.maxScore }}</td>
                                        </tr>
                                        <tr>&nbsp;</tr>
                                    </tbody>
                                </table>
                            </div>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
        <div v-if="assessments.length === 0" class="notification is-warning has-text-centered">
            No assessments have been assigned to this student.
        </div>
    </div>
  </div>
</template>

<script>
  const _ = require('lodash');
  const moment = require('moment');
  require('moment-timezone');
  moment.tz.setDefault('Africa/Johannesburg');
  
  import Vue from 'vue'
  import utils from '@/utils/utils.js';
  
  export default {
    name: 'ResourceActivities',
    components: {
    },
    props: [
        'intialResources', 'bookResources', 'privateResources', 'assessments', 'assessmentsDetails'
    ],
    watch: {
        // resources: {
        //     immediate: true, 
        //     handler (val, oldVal) {
        //         this.totalTasks = 0;
        //         this.totalLockedTasks = 0;
        //         this.totalOpenTasks = 0;
        //         this.totalAdditional = 0;
        //         this.totalLockedAdditional = 0;
        //         this.totalOpenAdditional = 0;
            // }
        // }
    },
    data: function () {
        var t = this;

        return {
            activeTab: 1,
            totalTasks: 0,
            totalLockedTasks: 0, 
            totalOpenTasks: 0,
            totalAdditional: 0,
            totalLockedAdditional: 0,
            totalOpenAdditional: 0,
            totalPushed: 0,
            totalAvg: 0,
            totalOpened: 0,
            totalPrivateCreated: 0,
            avgPrivateCreated: 0,
            resources: this.intialResources,
            sortedBookResources: this.bookResources,
            sortedPrivateResources: this.privateResources,
            loading: true,
            expandedLP: null,
            expandedAssessmentGroupId: null,
            additional: null,
            hoverLearningPathId: null,
            hoverLearningPathAdditional: null,
            expandedLPTopics: [],
            utils: utils
        }
    },
    computed: {
        assessmentsDetailsByGroupId() {
            return _.groupBy(this.assessmentsDetails, 'groupId');
        }
    },
    filters: {
        percent: function (value) {
            return Math.round(value * 100) + "%"
        },
        number: function (value) {
            return value.toFixed(1) 
        },
        resourceCategory: function (value) {
            switch (value) {
                case "flashcarddeck": return "Flashcard Deck";
                case "powerpoint": return "PowerPoint";
                default: return value.replace(/^\w/, c => c.toUpperCase());
            }
        }
    },
    mounted: function () {
        if(this.resources) {
            this.resources.forEach(lp => {
                this.totalTasks += lp.availableTasks;
                this.totalLockedTasks += lp.lockedTasks;
                this.totalOpenTasks += lp.openTasks;
                this.totalAdditional += lp.availableAdditional;
                this.totalLockedAdditional += lp.lockedAdditional;
                this.totalOpenAdditional += lp.openAdditional;
            });
        }

        this.sortedBookResources = this.bookResources.filter(r => r.bookIdOrEfId.startsWith('book'));
        this.sortedBookResources.sort((a, b) => {
            if (a[this.ordering] > b[this.ordering]) {
                return 1;
            } else if (a[this.ordering] < b[this.ordering]) {
                return -1;
            } else if (a.title > b.title) {
                return 1;
            } else if (a.title < b.title) {
                return -1;
            } else {
                return 0;
            }
        });

        this.totalPushed = 0;
        this.totalOpened = 0;
        this.totalAvg = 0;
        this.sortedBookResources.forEach(element => {
            this.totalPushed = this.totalPushed + element.total;
            this.totalOpened = this.totalOpened + element.seen;
        });
        this.totalAvg = this.totalPushed > 0 ? this.totalOpened / this.totalPushed : 0;

        this.sortedPrivateResources = this.privateResources.map(r => ({ avg: r.resources / r.users, ...r }));
        this.sortedPrivateResources.sort((a, b) => {
        if (a.category > b.category) {
            return 1;
        } else if (a.category < b.category) {
            return -1;
        } else {
            return 0;
        }
        });
        this.totalPrivateCreated = this.sortedPrivateResources.reduce((sum, x) => sum + x.count, 0);
        this.avgPrivateCreated = this.sortedPrivateResources.reduce((sum, x) => sum + x.resources, 0) / this.sortedPrivateResources.reduce((sum, x) => sum + x.users, 0);
    },
    methods: {
        hoverLearningPath(id, additional) {
            this.hoverLearningPathId = id;
            this.hoverLearningPathAdditional = additional;
        },
        expandAssessmentDetails(id) {
            if(this.expandedAssessmentGroupId === id) {
                this.expandedAssessmentGroupId = null;
            } else {
                this.expandedAssessmentGroupId = id;
            }
        },
        expandLP(id, additional) {
            if (this.expandedLP === id && this.additional === additional) {
                this.expandedLP = null;
                this.additional = null;
                this.expandedLPTopics = [];
            } else {
                this.expandedLP = id;
                this.additional = additional;

                const lp = this.resources.find(l => l.id === this.expandedLP);
                if (!lp) {
                    this.expandedLPTopics = [];
                } else {
                    if (this.additional) {
                        this.expandedLPTopics = lp.topics.filter(t => t.hasAdditional).map(t => {
                            const t2 = { ...t };
                            t2.items = t2.items.filter(i => !i.isTask);
                            t2.items.sort(this.sortItems);
                            return t2;
                        });
                    }
                    else {
                        this.expandedLPTopics = lp.topics.filter(t => t.hasTasks).map(t => {
                            const t2 = { ...t };
                            t2.items = t2.items.filter(i => i.isTask);
                            t2.items.sort(this.sortItems);
                            return t2;
                        });
                    }

                    this.expandedLPTopics.sort((a, b) => {
                        if (a.path > b.path) return 1;
                        else if (a.path < b.path) return -1;
                        else return 0;
                    });
                }
            }
        }
    }
  }

</script>

<style scoped>
.has-background-light-blue {
    background-color: #88b4e7;
}

.resource-icon-container {
    text-align: right;
}

.horiz-scroll {
    overflow-x: scroll;
}

.has-cursor-hand {
    cursor: pointer;
}

.has-cursor-hand:hover {
    background: #3273dc;
    color: #fff;
}

.tabs.is-boxed li.is-active a {
    color: #363636 !important;
}

.is-fullwidth {
    width: 100%;
}
</style>